import React from "react";
import { Survey } from "./survey-types";
import SurveyDefinition from "./SurveyDefinition";
interface PreviewStepProps {
  survey: Survey;
}

const PreviewStep: React.FC<PreviewStepProps> = ({ survey }) => {
  return (
    <div>
      <SurveyDefinition survey={survey} />
    </div>
  );
};

export default PreviewStep;
